import Settings from '../../../../../../settings/Settings';

const LABEL = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 60,
    TINT: 0x3f5174,
};

export default class Place extends Phaser.GameObjects.Container {
    private icon!: Phaser.GameObjects.Image;
    private label!: Phaser.GameObjects.BitmapText;

    constructor(scene: Phaser.Scene, x: number, y: number, place: number) {
        super(scene, x, y);

        if (place <= 3) {
            this.setupIcon(place);
        } else {
            this.setupLabel(place);
        }
    }

    setupIcon(place: number) {
        let x = 0;
        let y = -4;
        let frame = `gui/common/rank_${place}`;

        this.icon = this.scene.add.image(x, y, 'atlas', frame);
        this.add(this.icon);
    }

    setupLabel(place: number) {
        let x = 0;
        let y = -8;
        let text = `#${place}`;

        this.label = this.scene.add.bitmapText(x, y, LABEL.FONT, text, LABEL.SIZE);
        this.label.setOrigin(0.5);
        this.label.setTint(LABEL.TINT);
        this.add(this.label);
    }
}
